(ns arthur.domain.onion
  "Editor-only ghosts of the picture a few frames either side of the playhead.

  THE STAGE AT ANOTHER FRAME, nothing more. The resolver already draws any
  frame, so a ghost is what it draws `n` frames back or ahead — whatever is
  animating, by spans, keys or anything else, shows up without being looked
  for.")

(def defaults {:on? false :before 1 :after 1 :opacity 0.25})

(defn frames
  "The output frames to ghost around frame `f` of a `length`-frame transport:
  `before` back and `after` ahead, each tagged with its direction, nearest
  first, and none off either end."
  [f length {:keys [before after]}]
  (concat
   (for [i (range 1 (inc before)) :let [g (- f i)] :when (<= 0 g)]
     {:frame g :direction :before})
   (for [i (range 1 (inc after)) :let [g (+ f i)] :when (< g length)]
     {:frame g :direction :after})))
